<template>
    <div class="appointment">
        <div class="page-top">
            <div class="logo" @click="goto('/')">
                <div class="picbox">
                    <div class="pic" style="background-image: url(/img/logo.png)"></div>
                </div>
            </div>
            <div class="titlebox">专家与门诊预约</div>
        </div>
        <div class="contentbox">
            <div class="left-con">
                <div class="searchbar">
                    <div class="input">
                        <div class="icon">
                            <div class="picbox">
                                <div class="pic" style="background-image: url(/img/search.png)"></div>
                            </div>
                        </div>
                        <input class="search" type="text" maxlength="30" placeholder="姓名检索" v-model="titleSearch" @input="filterData">
                    </div>
                    <div class="input">
                        <div class="icon">
                            <div class="picbox">
                                <div class="pic" style="background-image: url(/img/search.png)"></div>
                            </div>
                        </div>
                        <input class="search" type="text" maxlength="30" placeholder="主治病症" v-model="zhuzhiSearch" @input="filterData">
                    </div>
                </div>
                <div class="itemlist">
                    <!-- <div class="item" v-for="(item, index) in doctors" :key="index" @click="contentShow(item.id)"> -->
                    <div class="item" v-for="(item, index) in resultDoctors" :key="index">
                        <div class="img">
                            <div class="picbox">
                                <div class="pic" :style="{backgroundImage: 'url(' + baseUrl + item.imgUrl +')'}"></div>
                            </div>
                        </div>
                        <div class="itemtitle">
                            <div class="title">{{item.title}}<span class="subtitle">{{item.categoryTitle}}</span></div>
                            <div class="detail">
                                <div class="d1">
                                    <div class="picbox">
                                        <div class="pic" style="background-image: url(/img/book.png)"></div>
                                    </div>
                                    <div class="txt">主治：{{item.fields.zhuzhi}}</div>
                                </div>
                                <div class="d2">
                                    <div class="picbox">
                                        <div class="pic" style="background-image: url(/img/time.png)"></div>
                                    </div>
                                    <div class="txt">门诊时间：{{item.fields.shijian}}</div>
                                </div>
                                <div class="d3">服务承诺：{{item.fields.fuwu}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-con">
                <div class="right-top-con">
                    <div class="taglist">
                        <div class="tag" :class="{active:tagindex===index}" v-for="(item, index) in tag" :key="index" @click="tagclick(item.id,index)">{{item.title}}</div>
                        <div class="tag2s">
                            <div class="tag2" v-for="(item, index) in taglist" :key="index" @click="contentShow(item.id)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="guide">
                        <div class="titlebox">医院门诊时间</div>
                        <div class="times" v-html="base.sjMenZhen"></div>
                        <!-- <div class="t1">
                            <div class="day">周一<span></span>~<span></span>周五：</div>
                                <div class="time">
                                上午8:00~11:30&emsp;下午13:30~17:00
                                </div>
                        </div>
                        <div class="t2"><div class="day">周<span></span>六：</div><div class="time">上午8:00~11:30</div></div>
                        <div class="t3"><span>*</span>国家法定节假日开诊时间按实际情况提前具体通知</div> -->
                    </div>
                </div>
                <div class="right-bottom-con">
                    <div v-if="btns.length > 2" class="btns">
                        <button class="btn" @click="contentShow(btns[0].id)" style="background-image: url(/img/bg_jzlc.png)">
                            <div class="txt">{{btns[0].title}}</div>
                            <div class="arrow">
                                <div class="picbox">
                                    <div class="pic" style="background-image: url(/img/btn_arrow.png)"></div>
                                </div>
                            </div>
                        </button>
                        <button class="btn" @click="contentShow(btns[1].id)" style="background-image: url(/img/bg_jky.png)">
                            <div class="txt">{{btns[1].title}}</div>
                            <div class="arrow">
                                <div class="picbox">
                                    <div class="pic" style="background-image: url(/img/btn_arrow.png)"></div>
                                </div>
                            </div>
                        </button>
                        <button class="btn" @click="contentShow(btns[2].id)" style="background-image: url(/img/bg_wxgzhyyzy.png)">
                            <div class="txt">{{btns[2].title}}</div>
                            <div class="arrow">
                                <div class="picbox">
                                    <div class="pic" style="background-image: url(/img/btn_arrow.png)"></div>
                                </div>
                            </div>
                        </button>
                        <!-- <button class="btn">
                            <div class="txt">健康云APP预约指引</div>
                            <div class="arrow">
                                <div class="picbox">
                                    <div class="pic" style="background-image: url(/img/btn_arrow.png)"></div>
                                </div>
                            </div>
                        </button>
                        <button class="btn">
                            <div class="txt">就诊流程及医保支付指引</div>
                            <div class="arrow">
                                <div class="picbox">
                                    <div class="pic" style="background-image: url(/img/btn_arrow.png)"></div>
                                </div>
                            </div>
                        </button> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="popup" :class="{active: detailShow}">
            <div class="shadow" @click="detailShow = false"></div>
            <div class="detail-popup">
                <div class="titlebox">
                    <div class="atitle">{{popupTitle}}</div>
                    <div class="close" @click="detailShow = false">
                        <div class="picbox">
                            <div class="pic" style="background-image: url(/img/close.png)"></div>
                        </div>
                    </div>
                </div>
                <div class="conbox" v-html="string" style="white-space:pre-wrap;"></div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { getBase } from "@/js/request";
import { getPro } from "@/js/request";
import { getInfo,getCategory2,getPage } from "@/js/request";

export default {
    name: 'Appointment',
    components: {

    },
    data() {
        return {
            base: {},
            baseUrl: '',
            doctors: [],
            resultDoctors: [],
            tag: [],
            tagindex:0,
            taglist: [],
            btns: [],
            popupTitle: '',
            string: '',
            detailShow: false,
            titleSearch: '',
            zhuzhiSearch: '',
        }
    },
    methods: {
        goto(adress, cate) {
            this.$router.push({path: adress, query: cate});
        },
        detailPopup() {
            this.detailShow = !this.detailShow;
        },
        contentShow(id) {
            getInfo(id).then(res => {
                let content = res.data.content;
                if(content != null && content != ""){
                    this.string = content.replaceAll("src=\"", "src=\"" + this.baseUrl);
                }else{
                    this.string = res.data.content;
                }
                this.popupTitle = res.data.title;
            });
            setTimeout(() => {
                this.detailShow = true;
            }, 500);
        },
        tagclick(cid,index){
            this.tagindex=index;
            getPage(1,cid).then(res =>{
                this.taglist = res.data;
            });
        },
        filterData(){
            this.resultDoctors = [];
            this.doctors.forEach(element => {
                if (element.title.includes(this.titleSearch) && element.fields.zhuzhi.includes(this.zhuzhiSearch)) {
                    this.resultDoctors.push(element)
                }
            });
        },
    },
    mounted() {
        this.$root.showRight();
        getBase().then(res => {
            this.base = res.data;
            this.baseUrl = res.config.baseURL;
        });
        getPro().then(res => {
            this.doctors = res.data;
            this.doctors.forEach(element => {
                getInfo(element.id).then(res => {
                });
            });
            this.resultDoctors = this.doctors;
        });
        getCategory2(8,55).then(res =>{
            this.tag = res.data;
            getPage(1,this.tag[0]['id']).then(res =>{
                this.taglist = res.data;
            });
        });
        getPage(1,54).then(res =>{
            this.btns = res.data;
        });
        // for(let id = 15; id <= 24; id++) {
        //     getContent(id).then(res => {
        //         if(id >= 18) {
        //             this.tag[id-18] = res.data.title;
        //         } else {
        //             this.btns[id-15] = res.data.title;
        //         }
        //     });
        // }
    }
}
</script>

<style lang="scss">
.appointment {
    padding: 20px 0;
    box-sizing: border-box;
    height: 100vh;
    width: 1400px;
    margin: 0 auto;
    .page-top {
        padding-left: 30px;
        margin-bottom: 20px;
        height: 110px;
        background: rgba(255,255,255,0.5);
        border-radius: 0px 0px 0px 0px;
        display: flex;
        align-items: center;          /* 垂直居中 */
        .logo {     
            @include sys-picbox(438px, 110px);
            display: flex;
            align-items: center;
            cursor: pointer;
        }
        .titlebox {
            @include sys-boxsize(40px, 40px);
            width: 236px;
            height: 56px;
            text-align: center;
            font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
            font-weight: bold;
            font-size: 26px;
            color: #3F65E0;
            text-align: left;
            font-style: normal;
            text-transform: none;
            background: #BCDDFF;
            border-radius: 50px 50px 50px 50px;

            margin-left: 20px;
            display: flex;                /* 开启 flex 布局 */
            justify-content: center;      /* 水平居中 */
            align-items: center;          /* 垂直居中 */
        }
    }
    .contentbox {
        display: flex;
        width: 100%;
        height: calc(100% - 150px);
        box-shadow: 0px 0px 50px 0px rgba(63,101,224,0.05);
        box-sizing: border-box;
        position: relative;
        &::-webkit-scrollbar {
            width: 3px;
        }
        &::-webkit-scrollbar-thumb {
            background: $acolor;
            border-radius: 2px;
        }
        &::-webkit-scrollbar-resizer {
            background: $acolor;
        }
        &::-webkit-scrollbar-track-piece {
            background: #fff;
            border-radius: 2px;
        }
        .left-con {
            @include sys-boxsize(100%, 100%, 24px, rgba(255,255,255,0.5));
            border: 2px solid #FFFFFF;
            padding: 25px 25px;
            flex: 1;
            height: auto;
            overflow-y: auto !important;

            .searchbar {
                flex: none;
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .input {
                    @include sys-boxsize(200px, 70px, 12px, #D8EBFF);
                    border: 2px solid #3F65E0;
                    display: flex;
                    align-items: center;
                    margin-right: 30px;
                    padding: 0 20px;
                    box-sizing: border-box;

                    &:last-child {
                        width: 100%;
                    }

                    .icon {
                        @include sys-picbox(20px, 20px);
                        margin-right: 10px;
                        flex: none;
                    }

                    .search {
                        @include sys-font(22px, #333333, bold);
                        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }

                    input::placeholder {
                        @include sys-font(20px, #333333);
                        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }

                    input {
                        @include sys-font(20px, #333);
                        flex: 1;
                        height: 100%;
                        background-color: transparent;
                    }
                }
            }

            .itemlist {
                width: 100%;

                .item {
                    display: flex;
                    width: 100%;
                    margin-bottom: 40px;
                    cursor: pointer;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    .img {
                        width: 100px;
                        height: 100px;
                        border-radius: 50%;
                        margin-right: 30px;
                        flex: none;
                        overflow: hidden;
                        @include sys-picbox(100%, 100%, cover);
                    }
                    .itemtitle {
                        .title {
                            display: flex;
                            align-items: flex-end;
                            @include sys-text-hide(1);
                            @include sys-font(28px, #333333, bold);

                            font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
                            text-align: left;
                            font-style: normal;
                            text-transform: none;

                            line-height: 36px;
                            margin-bottom: 12px;
                            .subtitle {
                                @include sys-font(18px, #3F65E0, bold);
                                line-height: 20px;
                                margin-left: 6px;
                                padding: 5px 10px;
                                font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;

                                background: #BCDDFF;
                                border-radius: 50px 50px 50px 50px;
                                justify-content: center;      /* 水平居中 */
                                align-items: center;          /* 垂直居中 */
                            }
                        }
                        .detail {
                            @include sys-picbox(16px, 16px);
                            .picbox {
                                flex: none;
                                margin-top: 3px;
                            }
                            .txt {
                                @include sys-text-hide(3);
                                @include sys-font(22px, #333);
                                line-height: 22px;
                                margin-left: 20px;
                            }
                            .d1, .d2 {
                                display: flex;
                                margin-bottom: 12px;

                                @include sys-font(22px, #333);
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                            }
                            .d3 {
                                @include sys-text-hide(3);
                                @include sys-font(20px, #6280E1);
                                line-height: 20px;

                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                            }
                        }
                    }
                }
            }
        }
        .right-con {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 600px;
            height: 100%;
            flex: none;
            margin-left: 20px;
            .right-top-con {
                flex: 1;
                @include sys-boxsize(100%, auto, 24px, rgba(255,255,255,0.5));
                border: 2px solid #FFFFFF;
                padding: 25px 0 5px 0;
                .taglist {
                    display: flex;
                    flex-wrap: wrap;
                    max-height: 800px;
                    overflow: hidden;
                    flex: none;
                    .tag {
                        @include sys-boxsize(160px, 44px, 12px, #FFFFFF);
                        @include sys-text-hide(1);
                        @include sys-font(22px, #3F65E0);
                        line-height: 44px;
                        text-align: center;
                        border: 2px solid #B2C4FF;
                        box-sizing: border-box;
                        margin: 10px 15px;
                        cursor: pointer;
                        transition: all .3s;
                        &:hover,&.active {
                            background: #3F65E0;
                            color: #FFFFFF;
                        }
                        &:first-child {
                            margin-left: 30px;
                        }
                    }
                    .tag2s {
                        display: flex;
                        flex-wrap: wrap;
                        height: calc(100vh - 810px)!important;
                        overflow-y: auto !important;
                        margin-left: 20px;
                        margin-right: 20px;
                        // flex: none;
                        .tag2 {
                            @include sys-boxsize(auto, 40px, 20px, #BCDDFF);
                            @include sys-text-hide(1);
                            @include sys-font(18px, $acolor);
                            text-align: center;
                            border: 2px solid #B2C4FF;
                            box-sizing: border-box;
                            margin: 5px 5px;
                            padding: 5px;
                            cursor: pointer;
                            transition: all .3s;
                        }
                    }
                }
                .guide {
                    margin: 10px;
                    .titlebox {
                        @include sys-font(26px, #333, bold);
                        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
                    }
                    .times {
                        @include sys-font(22px, #333);
                        line-height: 30px;
                        letter-spacing: 1px;
                        white-space: pre-wrap;
                        
                        &>div {
                            display: flex;
                            margin-bottom: 10px;
                        }
                        .t3 {
                            span {
                                color: #FF0000;
                            }
                        }
                        .day {
                            width: 100px;
                            flex: none;
                            display: flex;
                            span {
                                flex: 1;
                            }
                        }
                        .time {
                            flex: 1;
                        }
                    }
                }
            }
            .right-bottom-con {
                padding-top: 5px;

                flex: 1;
                .btns {
                    .btn {
                        @include sys-boxsize(100%, 80px, 10px, $acolor);
                        @include sys-flex(space-between, row);
                        background-size: cover!important;
                        background-position: center center!important;
                        background-repeat: no-repeat!important;
                        margin-bottom: 10px;
                        padding: 30px;
                        box-sizing: border-box;
                        .txt {
                            @include sys-text-hide(1);
                            @include sys-font(26px, #fff, bold);
                            flex: 1;
                        }
                        .arrow {
                            flex: none;
                            padding: 10px;
                            @include sys-picbox(14px, 10px);
                            .picbox {
                                .pic {
                                    
                                }
                            }
                        }
                        &:last-child {
                            margin-bottom: 10px;
                        }
                    }
                }
            }
        }
    }
    .popup {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 999;
        opacity: 0;
        visibility: hidden;
        &.active {
            opacity: 1;
            visibility: visible;
            .detail-popup {
                opacity: 1;
            }
        }
        .shadow {
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, .8);
        }
        .detail-popup {
            @include sys-flex();
            @include sys-boxsize(1200px, 800px, 20px, #fff);
            padding: 0 60px 60px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: opacity .6s;
            opacity: 0;
            .titlebox {
                @include sys-flex(space-between, row);
                width: 100%;
                height: 120px;
                margin-bottom: 40px;
                flex: none;
                position: relative;
                &::after {
                    content: '';
                    width: 100%;
                    height: 2px;
                    background: #EEEEEE;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                }
                .atitle {
                    @include sys-text-hide(1);
                    @include sys-font(36px, #000, bold);
                }
                .close {
                    @include sys-radius-btn(40px, 40px, #000);
                    @include sys-picbox(16px, 16px);
                    overflow: hidden;
                    transition: transform .3s;
                    cursor: pointer;
                    &:hover {
                        transform: rotate(90deg);
                    }
                }
            }
            .conbox {
                flex: 1;
                width: 100%;
                padding: 0 30px 30px 30px;
                box-sizing: border-box;
                @include sys-font(20px, #000);
                overflow-y: auto !important;
                &::-webkit-scrollbar {
                    width: 3px;
                }
                &::-webkit-scrollbar-thumb {
                    background: $acolor;
                    border-radius: 2px;
                }
                &::-webkit-scrollbar-resizer {
                    background: $acolor;
                }
                &::-webkit-scrollbar-track-piece {
                    background: #fff;
                    border-radius: 2px;
                }
                p {
                    text-indent: 40px;
                }
            }
        }
    }
}
</style>